/**
 * Form/action shape for the Proffix connect step.
 *
 * The customer supplies five fields in the connect modal; the service maps them into
 * the generic create envelope (`POST /api/integrations/proffix` with
 * `{ displayName, vendorInput: { serverUrl, restApiKey, username, password } }`). The BE's
 * `ProffixAuthAdapter` then checks the PxRestAPI (`PRO/Info`, `PRO/Datenbank`), logs in
 * against the first Mandant with module FIB, reads `FIB/FibuStammdaten` and logs out again,
 * all atomically before persisting the connection.
 *
 * Security note: `restApiKey` and `password` flow through the NgRx action stream and HTTP
 * call. Both are encrypted at rest on the BE side via a per-connection DEK. Do NOT log this
 * object or echo it back to the user.
 */
export interface IProffixConnectBody {
    /** UI label for the connection, surfaced in the manage modal server list. */
    displayName: string;
    /**
     * Customer's PxRestAPI URL: the origin incl. port (`https://proffix.example.ch:11011`),
     * optionally followed by `/pxapi/V4`. The BE normalises it to the origin.
     */
    serverUrl: string;
    /** PxRestAPI password (server-level secret, sent as `?key=` by the BE). Sensitive. */
    restApiKey: string;
    /** Proffix login username. Not secret. */
    username: string;
    /** Proffix login password. Sensitive. */
    password: string;
}
